/* eslint global-require:"off" */
var flatten = require('flat');

module.exports = flatten({
  title: 'Arcblock | 区块链 3.0',
  description: 'Born for blockchain 3.0',
  keywords: 'blockchain, platform, cloud, developer, arcblock',
  blog: {
    unlockTip: '这是一篇仅 ABT 钱包用户可阅读全文的文章，请登录以解锁剩余内容。'
  },
  contactForm: {
    signup: '邮件订阅',
    name: '请输入名称',
    email: '请输入邮箱',
    subscribe: '订阅'
  },
  menu: {
    learning: '学习培训',
    roadmap: '路线图',
    login: '登录',
    logout: '注销',
    solution: '解决方案',
    wallet: 'ABT 钱包',
    blocklet: 'Blocklet',
    developer: {
      'engineer-blog': '工程博客',
      'getting-started': '快速入门',
      description: '各种入门教程，SDK 文档，以及所有能帮助开发者的资源',
      overview: '概览',
      documentation: '文档',
      github: '开源代码',
      main: '开发者',
      support: '技术支持',
      title: '我们已经为您准备妥当',
      whitepaper: '白皮书',
      community: '开发者社区',
      workshop: 'DApps Workshop'
    },
    platform: {
      main: '区块链平台',
      title: '端到端的区块链应用开发平台',
      description: '方便你构建、部署和管理下一代去中心化应用的平台',
      overview: '概览',
      pricing: '报价',
      network: 'ABT 链网',
      node: 'ABT 链节点',
      forge: 'Forge SDK',
      ocap: '开放链访问协议',
      did: 'DID',
      console: '管理控制台',
      miner: '矿工'
    },
    about: {
      main: '关于我们',
      title: '关于我们',
      description: '了解 ArcBlock 的更多信息，浏览常见问题，或者成为我们的合作伙伴',
      overview: '公司简介',
      faq: '常见问题',
      partner: '合作伙伴'
    }
  },
  // post related
  post: {
    categories: '分类',
    tags: '标签',
    posts: '文章',
    backToPosts: '返回文章列表',
    postsByCategory: '分类“{category}”下的文章',
    postsByTag: '标签“{tag}”下的文章',
    nextPage: '下一页',
    previousPage: '上一页',
    continueReading: '继续阅读',
    viewAll: '查看所有'
  },
  footer: require('./footer/zh')
});